export const calcScorePerUserForTournament = (data: any, userScores: any, tournamentID: any) => {
  var score;
  if (userScores) {
    const games = getTournamentGames(data, tournamentID);
    games.forEach((game: any) => {
      let gameScore = userScores[game.gameID]?.score;
      if (Number.isInteger(gameScore)) {
        if (!score) score = 0;
        score += gameScore;
      }
    });
  }
  return score;
};

export const calcScorePerUserForGame = (userScores: any, gameID: any) => {
  return userScores && userScores[gameID]?.score;
};

export const getScorePerPlayer = (data: any, gameID: any, playerNumber: any) => {
  const score = data.Results && data.Results[gameID] && data.Results[gameID][playerNumber]?.score;
  return score ? parseInt(score) : score;
};

export const getBonusPerPlayer = (data: any, gameID: any, playerNumber: any) => {
  const bonus = data.Results && data.Results[gameID] && data.Results[gameID][playerNumber]?.bonus;
  return bonus ? Math.max(parseInt(bonus), 0) : bonus;
};

export const getTournamentGames = (data: any, tournamentID: any) => {
  const games: any = [];
  for (let gameID in data?.Games) {
    let game = data?.Games[gameID];
    if (game?.tournamentID == tournamentID) games.push(game);
  }
  return games;
};

export const getNextGame = (data: any, gameID: any) => {
  const tournamentID = data?.Games[gameID].tournamentID;
  for (let gameid in data?.Games) {
    let game = data?.Games[gameid];
    if (game.tournamentID == tournamentID && parseInt(gameid) > parseInt(gameID)) return game;
  }
};

export const getUserGameBet = (userBets: any, gameID: any) => {
  var gameBet;
  for (let key in userBets) {
    let bet = userBets[key];
    if (bet.gameID === gameID) gameBet = bet;
  }
  return gameBet;
};

export const getUserTournamentPlayoff = (userPlayoffs: any, tournamentID: any) => {
  var lastSave;
  for (let key in userPlayoffs) {
    let bet = userPlayoffs[key];
    if (bet.tournamentID == tournamentID) lastSave = bet;
  }
  return lastSave;
};

export const getUserTournamentBet = (data: any, userBets: any, tournamentID: any) => {
  var gameBet;
  for (let key in userBets) {
    let bet = userBets[key];
    if (data.Games[bet.gameID].tournamentID == tournamentID) gameBet = bet;
  }
  return gameBet;
};

export const getUserLastBet = (userBets: any) => {
  if (!userBets) return null;
  const bets = Object.values(userBets);
  return bets[bets.length - 1];
};

export const getPlayersByRoles = (data: any) => {
  const roles: any = {};
  console.log(data.Positions);

  data.Positions.map((pos: any) => {
    if (!pos) return;
    console.log(pos);

    roles[pos.positionID] = {
      positionID: pos.positionID,
      description: pos.description,
      players: [],
    };
  });
  data.Players.map((player: any) => {
    if (!player) return;
    if (roles[player.positionID]) roles[player.positionID].players.push(player); //!!!!!!!!!!!!!!!!!!!!!!!
  });
  return Object.values(roles);
};

export const findPlayerByProp = (data: any, prop: any, value: any) => {
  const playerArr = Object.values(data.Players);
  for (let i = 0; i < playerArr.length; i++) {
    let player: any = playerArr[i];
    if (player[prop] === value) return player;
  }
};

export const numberOfChooses = (data: any) => {
  var num = 0;
  for (let key in data.Positions) {
    let pos = data.Positions[key];
    if (pos.needToChoose) num += parseInt(pos.needToChoose);
  }
  return num;
};

export const sortByProp = (data: any, prop: any, ASC: any = true) => {
  data.sort((a: any, b: any) => {
    return parseInt(a[prop]) > parseInt(b[prop]) ? ASC * 2 - 1 : (!ASC as any) * 2 - 1;
  });
  return data;
};
